import type { Timestamp } from '@viamrobotics/web-client/google/protobuf/timestamp';

export const getMostRecentOrgID = (
  orgLastAccess: Record<string, Timestamp> | undefined
): string | undefined => {
  if (!orgLastAccess) {
    return undefined;
  }
  const sorted = Object.entries(orgLastAccess).sort(
    ([, orgATime], [, orgBTime]) => {
      // The "seconds" field is a string, so convert to number
      // also ignores nanosecond precision, but for something like recent organizations
      // that granularity probably doesn't matter for UX
      const orgADate = Number(orgATime.seconds);
      const orgBDate = Number(orgBTime.seconds);
      return orgBDate - orgADate;
    }
  );
  return sorted[0]?.[0];
};
